<template>
    <v-dialog v-model="dialog" width="50%" persistent>
        <v-card v-if="!loading">       
            <v-card-title class="primary white--text">Máquinas para {{line.Descricao}}</v-card-title>
            <v-tabs v-model="tab" background-color="warning" dark fixed-tabs>
                <v-tab>Eq. Interno</v-tab>
                <v-tab>Eq. Externo</v-tab>
                </v-tabs>
        
                <v-tabs-items v-model="tab">
                <!-- Tab MO Interna -->
                <v-tab-item>
                    <v-card-text>
                        <v-row v-for="(item, index) in internos_a_mostrar" :key="index" class="mt-4">
                            <v-col cols="12" md="10">
                            <v-autocomplete
                                label="Equipamento"
                                :items="all_equipamentos.interno"
                                disabled
                                dense outlined
                                item-value="Id"
                                :item-text="item => item.EntityKey + ' - ' + item.Descricao"
                                v-model="item.equipamento"
                            />
                            </v-col>
                            <v-col cols="12" md="2">
                            <v-text-field
                                label="Horas"
                                dense outlined
                                v-model="item.hours"
                            />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-tab-item>
        
                <!-- Tab MO Externa -->
                <v-tab-item>
                    <v-card-text>
                        <v-row v-for="(item, index) in externos_a_mostrar" :key="index" class="mt-4">
                            <v-col cols="12" md="10">
                            <v-autocomplete
                                label="Equipamento"
                                :items="all_equipamentos.externo"
                                disabled
                                dense outlined
                                item-value="Id"
                                :item-text="item => item.EntityKey + ' - ' + item.Descricao"
                                v-model="item.equipamento"
                            />
                            </v-col>
                            <v-col cols="12" md="2">
                            <v-text-field
                                label="Horas"
                                dense outlined
                                v-model="item.hours"
                            />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-tab-item>
            </v-tabs-items>
  
            <v-card-actions>
                <v-row>
                    <v-col cols="12" align="center">
                        <v-btn class="success" rounded @click="save">Gravar</v-btn>
                        <v-btn class="error" rounded @click="$emit('close')">Fechar</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default{
    name: "MaoObraDialog",
    props:{
        unit: Object,
        equipamentos_externos:{
            typeof: Array,
            default: []
        },
        equipamentos: {
            typeof: Array,
            default: []
        },
        all_equipamentos:{
            typeof: Array,
            default: []
        },
        line:{
            typeof: Object,
            default: null
        },
        total_lines:{
            typeof: Number, 
        },
        divideAllMachines:{
          typeof: Boolean,
          default: false
        }
    },
    data(){
        return{
            dialog: true,
            loading: true,
            tab: 0, // Controla as tabs
            internos_a_mostrar: [],
            externos_a_mostrar: []
        }
    },
    mounted(){
        this.equipamentos.forEach(equipamento => {
            if(equipamento.classe_id == this.line.classe_id){
                let aux = {...equipamento}
                aux.hours = null

                if(this.divideAllMachines){
                    aux.hours = parseFloat(aux.hs) / this.total_lines
                }

                this.internos_a_mostrar.push(aux)
            }
        });

        
        this.equipamentos_externos.forEach(equipamento => {
            if(equipamento.classe_id == this.line.classe_id){
                let aux = {...equipamento}
                aux.hours = null

                if(this.divideAllMachines){
                    aux.hours = parseFloat(aux.hs) / this.total_lines
                }

                this.externos_a_mostrar.push(aux)
            }
        });

        this.line.linhas_eq_internal.forEach(linha => {
          this.internos_a_mostrar.forEach(equipamento => {
              if(linha.equipamento == equipamento.equipamento)
                if(!this.divideAllMachines)
                    equipamento.hours = linha.hours

              equipamento.hours = equipamento.hours == null ? null : parseFloat(equipamento.hours).toFixed(2)
          });
        });

        this.line.linhas_eq_external.forEach(linha => {
            this.externos_a_mostrar.forEach(equipamento => {
                if(linha.equipamento == equipamento.equipamento)
                    if(!this.divideAllMachines)
                        equipamento.hours = linha.hours

                equipamento.hours = equipamento.hours == null ? null : parseFloat(equipamento.hours).toFixed(2)
                
            });
        });

       
        this.loading = false
    },
    methods:{
        save(){
            this.internos_a_mostrar.forEach(element => {
                let data = null
                this.line.linhas_eq_internal.forEach(linhas => {
                    if(element.equipamento == linhas.equipamento){
                        data = element
                        linhas.hours = element.hours
                        linhas.type = 'I'
                    }
                });

                if(data == null){
                    data = {
                        equipamento: element.equipamento,
                        hours: element.hours
                    }

                    this.line.linhas_eq_internal.push(data)
                }
            });        
            
            
            
            this.externos_a_mostrar.forEach(element => {
                let data = null
                this.line.linhas_eq_external.forEach(linhas => {
                    if(element.equipamento == linhas.equipamento){
                        data = element
                        linhas.hours = element.hours
                        linhas.type = 'E'
                    }
                });

                if(data == null){
                    data = {
                        equipamento: element.equipamento,
                        hours: element.hours
                    }

                    this.line.linhas_eq_external.push(data)
                }
            });

            return Promise.resolve();
        }
    }
}
</script>